export { default } from "./MainIdeaOrganizer";
export * from "./MainIdeaOrganizer";
